<template>
	<vx-card>
		<table class="order__details">
			<tbody>
			<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('site') }}</b></td>
				<td>
					{{ websiteName }}
				</td>
			</tr>
			<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('client') }}</b></td>
				<td>
					<RouterLink :to="`/${pathToClient}/${clientId}`">
						{{ clientName }}
					</RouterLink>
				</td>
			</tr>
			<tr>
				<td><b>{{ $t('workName') }}</b></td>
				<td>{{ model.name }}</td>
			</tr>
			<tr>
				<td><b>{{ $t('workLanguage') }}</b></td>
				<td>
					{{ $getDeep(model.language, languages) }}
				</td>
			</tr>
			<tr>
				<td><b>{{ $t('subjectArea') }}</b></td>
				<td>
					{{ $getDeep(model.subject, subjects) }}
				</td>
			</tr>
			<tr>
				<td><b>{{ $t('qualityLevel') }}</b></td>
				<td>{{ $getDeep(model.quality_level, levels) }}</td>
			</tr>
			<tr>
				<td><b>{{ $t('dueDate') }}</b></td>
				<td>{{ model.due_date }}</td>
			</tr>
			<tr>
				<td><b>{{ $tc('attachedFiles', model.files.length) }}</b></td>
				<td>
					<div v-for="(file, index) in model.files" :key="index">
						<a

							target="_blank"
							:href="file.url"
						>
							{{ file.name }}
						</a>
						<br>
					</div>
				</td>
			</tr>
			<tr>
				<td><b>{{ $t('comment') }}</b></td>
				<td class="break-words hyphens-auto">
					{{ model.description }}
				</td>
			</tr>
			<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('paymentMethod') }}</b></td>
				<td>
					{{ $getDeep(model.pay_type, payTypes, "label") }}
				</td>
			</tr>
			<template
				v-for="(work, index) in model.work_types"
			>
				<tr :key="index + 'border'" class="top-border">
					<td class="top-border__container" colspan="2">
						<div class="top-border__line"></div>
					</td>
				</tr>
				<tr :key="index + 'type'">
					<td><b>{{ $t('workType') }}</b></td>
					<td>
						{{ $getDeep(work.work_type_id, works) }}
					</td>
				</tr>
				<tr :key="index + 'pages'">
					<td><b>{{ $t('pagesAmount') }}</b></td>
					<td>
						{{ work.pages_number }}
					</td>
				</tr>
			</template>
			</tbody>
		</table>
	</vx-card>
</template>

<script>
export default {
	name: "CardTicketView",
	props: {
		model: 		{ default: {} },
		subjects: 	{ default: [] },
		works:		{ default: [] },
		languages:	{ default: [] },
		levels:		{ default: [] },
		payTypes:	{ default: () => [] },
	},
	computed: {
		clientId() {
			if(!this.model.client) return "---";
			return this.model.client.id;
		},
		clientName() {
			if(!this.model.client) return "---";
			return this.model.client.full_name !== ""
				? this.model.client.full_name : "---";
		},
		pathToClient() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "client";
			} else if(role === "manager") {
				return "clientM";
			}
		},
		websiteName() {
			return this.model.website && this.model.website.name
				? this.model.website.name
				: "---";
		},
	},
}
</script>

<style lang="scss">
.order__details {
	width: 100%;
	border-spacing: 0;

	td {
		vertical-align: top;
	}

	tr > td:first-child {
		max-width: 45%;
		width: 45%;
		padding-right: 15px;
	}

	.top-border {
		column-span: 2;

		&__container {
			padding-top: 10px;
			padding-bottom: 15px;
		}

		&__line {
			border-top: 1px solid #e4e4e4;
		}
	}

	@media screen and (max-width: 500px) {
		tr > td:first-child {
			max-width: 50%;
			width: 50%;
		}
	}
}
</style>
